import Head from "next/head";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getNitoelEnv } from "components/EnvInfo";
import { useClientSnapshot } from "lib/useClientSnapshot";

type Props = {
  title?: string;
  primaryLang?: string;
};

// hostname はページの存続中には変わらない。SSR / hydration は接頭辞なしで描く。
const readEnvironmentPrefix = () => {
  try {
    const env = getNitoelEnv();
    return env !== "prod" && env !== "unknown" ? `[${env}] ` : "";
  } catch {
    return "";
  }
};

const PageHead: React.FC<Props> = ({ title, primaryLang }) => {
  const { t, ready } = useTranslation("common");
  const envPrefix = useClientSnapshot(readEnvironmentPrefix, []) ?? "";

  useEffect(() => {
    try {
      getNitoelEnv();
    } catch (e) {
      console.warn("Failed to detect environment in PageHead:", e);
    }
  }, []);

  const fallbackTitle = primaryLang === "ja" ? "ニトエル" : "nitoel";
  const serviceName = ready ? t("service_name") : fallbackTitle;

  return (
    <Head>
      {/* [環境名] 機能タイトル | ニトエル */}
      <title>{`${envPrefix}${title ? `${title} | ` : ""}${serviceName}`}</title>
    </Head>
  );
};

export default PageHead;
